import { isPlatformBrowser } from '@angular/common';
import { FamilyService } from './services/family/family.service';
import { OrdersService } from './services/order/orders.service';
import { PdvService } from './services/pdv/pdv.service';
import { Component, ElementRef, Inject, PLATFORM_ID, ViewChild } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Meta, Title } from '@angular/platform-browser';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'app';
  ourAppEvent;
  orderProg;
  alert;
  @ViewChild("template") template: ElementRef;
  bsModalRef: BsModalRef;
  constructor(
    private router: Router,
    private pdvService: PdvService,
    private ordersService: OrdersService,
    private familyService: FamilyService,
    private titleService: Title,
    @Inject(PLATFORM_ID) private platformId: Object,
    private modalService: BsModalService,
    private meta: Meta
  ) {
    this.ordersService.ourAppEvent.subscribe(
      data => {
        this.ourAppEvent = data;
      }
    )
    const subs8 = this.ordersService.orderProg.subscribe((orderProg) => {
      this.orderProg = orderProg;
    });
  }

  ngOnInit() {
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      if (isPlatformBrowser(this.platformId)) {
        if ((<any>window).ga) {
          (<any>window).ga('set', 'page', evt.urlAfterRedirects);
          (<any>window).ga('send', 'pageview');
        }
        window.scrollTo(0, 0);
      }
    });
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      if (isPlatformBrowser(this.platformId)) {
        window.scrollTo(0, 0);
      }
    });
    this.pdvService.getModesByPdv().subscribe(
      (data: any[]) => {
        this.pdvService.orderTypes.next(data);
        if (data.length > 0) {
          this.ordersService.orderType.next(data[0].id);
        }
      }
    );
    this.pdvService.getPdvInfo().subscribe(
      (data: any) => {
        this.pdvService.nbrOffersAuthorizedSite.next(data.nbrOffersAuthorizedSite);
        this.pdvService.pdv.next(data);
        this.ordersService.amountMiniDelivery.next(data.amountMiniOrder);
        this.ordersService.enablePayement.next(data.enablePayement);
        this.titleService.setTitle(data.name + " livre à domicile et au bureau");
        this.meta.addTag({ name: 'description', content: data.metaDescription });
        this.meta.addTag({ name: 'keywords', content: data.metaKeywords });
        if (isPlatformBrowser(this.platformId)) {
          if (data.alert) {
            this.alert = data.alert;
            this.bsModalRef = this.modalService.show(this.template, {
              class: "alert-modal"
            });
          }
          if (data.analytic) {
            this.loadAnalytic(data.analytic);
          }
        }
        if (this.getMobileOperatingSystem() == 'android') {
          if (data.android) {
            this.ordersService.ourAppEvent.next(true);
          }
        } else if (this.getMobileOperatingSystem() == 'iPhone') {
          if (data.ios) {
            this.ordersService.ourAppEvent.next(true);
          }
        }

      }
    )
    this.familyService.getFamiliesOfCarte().subscribe(
      (families: any[]) => {
        this.familyService.families.next(families);
      })
    this.familyService.getMenuCategoriesOfCarte().subscribe(
      (menucategories: any[]) => {
        this.familyService.menucategories.next(menucategories);
      }
    )
  }
  getMobileOperatingSystem() {
    if (isPlatformBrowser(this.platformId)) {
      var ua = navigator.userAgent.toLowerCase();
      var windows8 = ua.indexOf("windows nt 6.2") > -1
      var mobile = ua.indexOf("mobile") > -1 || ua.indexOf("wp7") > -1;
      var iPhone = ua.indexOf("iphone") > -1 || ua.indexOf("ipad") > -1;
      var android = ua.indexOf("android") > -1;
      var msie = ua.indexOf("msie") > -1;
      if (mobile && iPhone) return ('iPhone');
      else if (mobile && android) return ('android');
      else if (windows8) return ("windows8")
    }
  }
  loadAnalytic(trackingID) {
    let gaScript = document.createElement('script');
    gaScript.setAttribute('async', 'true');
    gaScript.setAttribute('src', `https://www.googletagmanager.com/gtag/js?id=${trackingID}`);
    let gaScript2 = document.createElement('script');
    gaScript2.innerText = `window.dataLayer = window.dataLayer || [];function gtag(){dataLayer.push(arguments);}gtag(\'js\', new Date());gtag(\'config\', \'${trackingID}\');`;
    document.documentElement.firstChild.appendChild(gaScript);
    document.documentElement.firstChild.appendChild(gaScript2);
  }
}
